<script setup lang="ts">
import { computed } from 'vue';

import HgGoldPartnerBadge from '@/assets/images/agent-badges/hg-gold-partner.png';
import HgSilverPartnerBadge from '@/assets/images/agent-badges/hg-silver-partner.png';
import Is24GoldPartnerBadge from '@/assets/images/agent-badges/is24-gold-partner.png';
import Is24SilverPartnerBadge from '@/assets/images/agent-badges/is24-silver-partner.png';
import { isPlatformIs24 } from '@/helpers/Platform/platform';
import type { PartnerBadgeTier } from '@/types';

interface PartnerBadge {
  alt: string;
  src: string;
}

defineOptions({
  name: 'AgencyPartnerBadge',
});

const props = withDefaults(
  defineProps<{
    partnerBadgeTier?: PartnerBadgeTier | null;
  }>(),
  { partnerBadgeTier: null },
);

const badge = computed<PartnerBadge | null>(() => {
  const badges: Record<PartnerBadgeTier, PartnerBadge> = isPlatformIs24()
    ? {
        gold: { alt: 'Gold Partner', src: Is24GoldPartnerBadge },
        silver: { alt: 'Silver Partner', src: Is24SilverPartnerBadge },
      }
    : {
        gold: { alt: 'Gold Partner', src: HgGoldPartnerBadge },
        silver: { alt: 'Silver Partner', src: HgSilverPartnerBadge },
      };

  return props.partnerBadgeTier ? badges[props.partnerBadgeTier] : null;
});
</script>

<template>
  <img
    v-if="badge"
    :class="$style.badge"
    :src="badge.src"
    :alt="badge.alt"
    data-test="agency-partner-badge"
  />
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.badge {
  display: block;
  width: $space-400;
  height: $space-400;

  @media (min-width: $viewport-md-min) {
    width: $space-500;
    height: $space-500;
  }
}
</style>
